import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { FaAngleRight } from '@react-icons/all-files/fa/FaAngleRight'
import odsWrapperContext from '../../../../context/odsWrapperContext'

function ButtonV3({ onClick, data, arrow }) {
  const { odsApiData } = useContext(odsWrapperContext)

  const { style, text } = data
  let buttonClass = ['button']
  const styleToCssClass = {
    Primary: 'button--primary',
    Secondary: 'button--secondary',
    Tertiary: 'button--tertiary'
  }
  buttonClass.push(styleToCssClass[style])
  buttonClass.push(style)
  buttonClass = buttonClass.join(' ')

  let eventValue

  // this conditional statement will remove soon in the follow up tickets
  if (odsApiData?.offerType === 'none' && text.includes('Yes')) {
    eventValue = () => {
      window.location.href = odsApiData?.prefillLink
    }
  } else if (odsApiData?.offerType === 'none' && text.includes('No')) {
    eventValue = onClick
  } else {
    eventValue = onClick
  }

  return (
    <button type="button" className={buttonClass} onClick={eventValue}>
      {text}
      {arrow ? <FaAngleRight className="arrow-right" role="img" /> : null}
    </button>
  )
}

ButtonV3.defaultProps = {
  onClick: () => {},
  arrow: 'false'
}

ButtonV3.propTypes = {
  onClick: PropTypes.func,
  data: PropTypes.object.isRequired,
  arrow: PropTypes.bool
}

export { query as data } from './buttonQuery'

export default ButtonV3
